const PAYMENT = {
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  REJECTED: 'REJECTED',
  EXPIRED: 'VOID',
};

export default PAYMENT;
